import createUseContext from 'constate';
import { useReducer } from 'react';
import { repo } from 'index';
import { errorHandler } from 'helpers/error-handler';
import { createReducer } from 'helpers/reducers-helper';
import merge from 'lodash/merge';

export const RESET = 'RESET';
export const CHANGE_OLD_PASSWORD = 'CHANGE_OLD_PASSWORD';
export const CHANGE_NEW_PASSWORD = 'CHANGE_NEW_PASSWORD';
export const CHANGE_CONFIRM_NEW_PASSWORD = 'CHANGE_CONFIRM_NEW_PASSWORD';
export const SUBMIT_START_CHANGE_PASSWORD = 'SUBMIT_START_CHANGE_PASSWORD';
export const SUBMIT_ERROR_CHANGE_PASSWORD = 'SUBMIT_ERROR_CHANGE_PASSWORD';

const old_password_input = 'old_password_input';
const new_password_input = 'new_password_input';
const confirm_new_password_input = 'conrfirm_new_password_input';

export const useChangePassword = onCloseEditMode => {
  const initState = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    loading: false,
    oldPasswordError: '',
    newPasswordError: '',
    confirmNewPasswordError: '',
    error: '',
  };

  const changeOldPassword = (state, payload) => merge(state, { oldPassword: payload });
  const changeNewPassword = (state, payload) => merge(state, { newPassword: payload });
  const changeConfirmNewPassword = (state, payload) => merge(state, { confirmNewPassword: payload });
  const submitStartChangePassword = state => merge({}, state, { error: '', loading: true });
  const submitErrorChangePassword = (state, payload) => {
    if (payload.which === old_password_input) {
      return merge({}, state, {
        loading: false,
        oldPasswordError: payload.msg,
        newPasswordError: '',
        confirmNewPasswordError: '',
      });
    } else if (payload.which === new_password_input) {
      return merge({}, state, {
        loading: false,
        oldPasswordError: '',
        newPasswordError: payload.msg,
        confirmNewPasswordError: '',
      });
    } else if (payload.which === confirm_new_password_input) {
      return merge({}, state, {
        loading: false,
        oldPasswordError: '',
        newPasswordError: '',
        confirmNewPasswordError: payload.msg,
      });
    }
  };

  const reset = () => initState;

  const changePassword = () => {
    if (state.oldPassword.length === 0) {
      dispatch({
        type: SUBMIT_ERROR_CHANGE_PASSWORD,
        payload: {
          msg: '請輸入原密碼',
          which: old_password_input,
        },
      });
    } else if (state.newPassword.length < 8) {
      dispatch({
        type: SUBMIT_ERROR_CHANGE_PASSWORD,
        payload: {
          msg: '密碼最少輸入八個字元',
          which: new_password_input,
        },
      });
    } else if (state.newPassword !== state.confirmNewPassword) {
      dispatch({
        type: SUBMIT_ERROR_CHANGE_PASSWORD,
        payload: {
          msg: '兩次密碼輸入不相同',
          which: confirm_new_password_input,
        },
      });
    } else {
      dispatch({ type: SUBMIT_START_CHANGE_PASSWORD });
      repo
        .changePassword(state.oldPassword, state.newPassword)
        .then(() => {
          dispatch({ type: RESET });
          onCloseEditMode();
        })
        .catch(error => {
          dispatch({
            type: SUBMIT_ERROR_CHANGE_PASSWORD,
            payload: {
              msg: errorHandler(error),
              which: confirm_new_password_input,
            },
          });
        });
    }
  };

  const reducer = createReducer(
    {
      [CHANGE_OLD_PASSWORD]: changeOldPassword,
      [CHANGE_NEW_PASSWORD]: changeNewPassword,
      [CHANGE_CONFIRM_NEW_PASSWORD]: changeConfirmNewPassword,
      [SUBMIT_START_CHANGE_PASSWORD]: submitStartChangePassword,
      [SUBMIT_ERROR_CHANGE_PASSWORD]: submitErrorChangePassword,
      [RESET]: reset,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return {
    state,
    dispatch,
    changePassword,
  };
};

export const useChangePasswordContext = createUseContext(useChangePassword);
